import { Component, OnInit } from '@angular/core';
import { LanguageService } from './services/language.service';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { Router } from '@angular/router';
import { CommonService } from './services/common.service';
import {
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import { Title } from '@angular/platform-browser';
import { UserService } from './services/user.service';
import { NgxPermissionsService } from 'ngx-permissions';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // pro
})
export class AppComponent implements OnInit {
  dir: string;
  loading = false
  constructor(private languageService: LanguageService,
    private _hotkeyService: HotkeysService,
    private router: Router,
    private commonService: CommonService,
    private titleService: Title) {

    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });


    this.titleService.setTitle('Sarafi Mohseni');

  }

  ngOnInit() {
    this.setTheme();

    this.languageService.setLanguage();



    var lan = localStorage.getItem('lan');
    if (lan == null || lan == undefined) {
      localStorage.setItem('dir', 'ltr');
      localStorage.setItem('lan', 'en');

    }


    this._hotkeyService.add(new Hotkey('alt+0', (event: KeyboardEvent): boolean => {
      this.router.navigateByUrl("/admin/history/history-transaction");
      return false; // Prevent bubbling
    }));
    this._hotkeyService.add(new Hotkey('alt+1', (event: KeyboardEvent): boolean => {
      this.router.navigateByUrl("/admin/transaction/add-transaction");
      return false; // Prevent bubbling
    }));

    this._hotkeyService.add(new Hotkey('alt+3', (event: KeyboardEvent): boolean => {
      this.router.navigateByUrl("/admin/customer/customer-list");
      return false; // Prevent bubbling
    }));


    //transaction list
    // this._hotkeyService.add(new Hotkey('alt+4',(event: KeyboardEvent): boolean => {
    //   this.router.navigateByUrl("/admin/add-transaction");
    //   return false; // Prevent bubbling
    // }));





    // this.userService.GetUserAccess().subscribe(res=>{
    //   res.forEach(item=>{
    //       this.permissions.push(item.permissionId);
    //   });
    //   // this.permissionService.
    //   this.permissionService.loadPermissions(this.permissions);
    // });
  }

  permissions: string[] = [];

  setTheme() {
    this.dir = localStorage.getItem('dir');

    if (this.dir == 'rtl') {
      //link['href'] = "/assets/styles.css";
      document.getElementById("body1").setAttribute("dir", "rtl");
      require("style-loader!./../assets/adminlte/fa/style.rtl.css");

    } else {
      document.getElementById("body1").setAttribute("dir", "ltr");
      require("style-loader!./../assets/adminlte/en/style-ltr.css");
    }
  }
}
